const get = require('lodash/get')
const keyBy = require('lodash/keyBy')
const {isDiscontinued} = require('../../product/tools')
const { DIRECT_ORDER_TYPES } = require('../../allocation/config')
const computeQto = require('../../forecast/tools/read/compute-qto')

exports.createForecastAllocations = async function (state, mainApi, {locations, deliveryDate, programId}) {
  const warnings = []
  locations.forEach(location => {
    if (!Object.keys(location.subscriptions).length) {
      warnings.push({
        locationId: location._id,
        locationName: location.fullName,
        errorType: 'subscription_missing',
        message: `${location._id} ${location.name} No subscriptions found`
      })
    }
  })
  const locationsWithSubscriptions = locations
    .filter(l => Object.keys(l.subscriptions).length)

  const forecastsByLocationId = {}
  for (let i = 0; i < locationsWithSubscriptions.length; i++) {
    const location = locationsWithSubscriptions[i]
    const [forecasts, ledger] = await Promise.all([
      mainApi.forecast.list({ locationIds: [location._id], program: programId }),
      mainApi.ledger.getOne(location._id)
    ])
    forecastsByLocationId[location._id] = computeQto(forecasts, ledger)[0]
  }

  const { products: allProductsById } = await mainApi.product.listForLocations(locations.map(loc => loc._id))
  const { prices } = await mainApi.price.list({ skus: Object.keys(allProductsById) })
  const productPricesById = keyBy(prices, 'sku')

  const allocations = locationsWithSubscriptions.map(location => {
    const {products, warnings: productWarnings} = getProducts(location, forecastsByLocationId[location._id], allProductsById, productPricesById)
    warnings.push(...productWarnings)
    return {
      location,
      products
    }
  })
  return {allocations, warnings}
}

function getProducts (location, forecast = {}, allProducts, productPricesById) {
  const latestAllocations = forecast.latestAllocation || {}
  const warnings = []
  const locationSubscriptions = location.subscriptions
  const products = Object.keys(locationSubscriptions)
    .reduce((acc, productId) => {
      const subscriptionType = get(locationSubscriptions[productId], 'forecast.type', '')
      const directOrder = get(locationSubscriptions[productId], 'forecast.directOrder', 0)
      const product = get(allProducts, productId, {})
      const productName = get(product, 'fullName', 'unknown product')
      const sellPrice = get(productPricesById, `${productId}.sellprice`, null)
      const discontinued = isDiscontinued(product)
      if (discontinued) return acc

      if (!sellPrice) {
        warnings.push({
          productId: productId,
          productName: get(allProducts[productId], 'fullName', 'unknown product'),
          errorType: 'no_sell_price',
          message: `This product has no sell price`
        })
        return acc
      }

      const latestAllocation = latestAllocations[productId]
      const allocationType = subscriptionType || 'allocation_missing'

      if (subscriptionType && subscriptionType === DIRECT_ORDER_TYPES.PAY_ON_DELIVERY) {
        const level = get(location, 'level')
        let original = directOrder

        if (level === 'pack-point' && directOrder === 0) {
          original = latestAllocation || 0
        }
        acc[productId] = { original, allocationType: DIRECT_ORDER_TYPES.PAY_ON_DELIVERY }
        return acc
      }

      if (latestAllocation === undefined) {
        warnings.push({
          locationId: location._id,
          locationName: location.fullName,
          productId: productId,
          productName,
          errorType: 'allocation_missing',
          message: `Missing forecast for ${location._id} and ${productId}. Could not calculate QTO`
        })
        acc[productId] = { original: 0, allocationType }
        return acc
      }

      acc[productId] = { original: latestAllocation, allocationType }
      return acc
    }, {})

  return {products, warnings}
}
